export const LOCALSTORAGE_SERVICE_RESTORE_KEY = '__ONLOG_SERVICE_RESTORE__';
export const LOCALSTORAGE_SERVICE_RESTORE_EXPIRE_DATE_KEY = '__ONLOG_SERVICE_RESTORE_EXPIRE_DATE__';